module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-nav"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    attrs: {
      "id": "row-nav-navbar"
    }
  }, [_c('ul', {
    staticClass: "list-basic-settings pull-right"
  }, [(_vm.type == 'home') ? [_vm._m(0)] : [_vm._m(1)], _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": _vm.enterWorkbench
    }
  }, [_vm._v("工作中心")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
    staticClass: "home-li-a"
  }, [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": _vm.apiLinks.selfHome,
      "target": "_blank"
    }
  }, [_vm._v("返回官网")])]), _vm._v(" "), _c('li', {
    staticClass: "cashome-li-a"
  }, [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": _vm.apiLinks.selfHome,
      "target": "_blank"
    }
  }, [_vm._v("返回官网")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
    staticClass: "cashome-li-a"
  }, [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": _vm.caslogout
    }
  }, [_vm._v("退出")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": "home.html"
    }
  }, [_vm._v("首页")]), _vm._v("   |  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "row-nav-a",
    attrs: {
      "href": "cashome.html"
    }
  }, [_vm._v("首页")]), _vm._v("   |  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb91716e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-header.vue
// module id = 19
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15 16 17